import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const averageAsync = async (source, selector) => {
    let value = 0;
    let count = 0;
    for (const item of source) {
        value = value + await selector(item);
        count = count + 1;
    }
    if (count === 0) {
        throw new InvalidOperationException(ErrorString.NoElements);
    }
    return value / count;
};
